import { getSupportedDevicesSync } from "./supportedDevicesStore";

type SupportedKb = {
  vendorId: number;
  productId: number;
  keyboardType?: string;
  solutionRovider?: string;
};

/**
 * 从 equipment / 设备目录解析 keyboardType（社区分享、华丰达读盘、预览矩阵共用）。
 * 禁止在无型号信息时回退到「当前连接的最后一台设备」——多设备并存时会错位。
 */
export function resolveEquipmentKeyboardType(
  equipmentData: Record<string, unknown> | null | undefined
): string {
  if (!equipmentData || typeof equipmentData !== "object") {
    return "68";
  }

  const raw =
    equipmentData.keyboardType ??
    (equipmentData as { keyboard_type?: unknown }).keyboard_type;
  const fromEq = String(raw ?? "").trim();
  if (fromEq && fromEq !== "undefined" && fromEq !== "null") {
    return fromEq;
  }

  const vid = Number(equipmentData.vendorId ?? 0);
  const pid = Number(equipmentData.productId ?? 0);
  const solution = String(equipmentData.solutionRovider ?? "").trim();

  if (vid && pid) {
    const list = getSupportedDevicesSync().keyboard as SupportedKb[];
    const hits = list.filter(
      (d) => Number(d.vendorId) === vid && Number(d.productId) === pid
    );
    const hit =
      (solution &&
        hits.find((h) => String(h.solutionRovider ?? "") === solution)) ||
      hits[0];
    if (hit?.keyboardType) {
      return String(hit.keyboardType);
    }
  }

  const pn = String(equipmentData.productName ?? "");
  const dn = String(
    (equipmentData as { displayname?: unknown }).displayname ??
      (equipmentData as { displayName?: unknown }).displayName ??
      ""
  );
  const blob = `${pn} ${dn}`.toUpperCase();

  if (/\bDEEP80\s*MAX\b/i.test(blob)) {
    return "deep80max";
  }
  if (/\bSMART875\b/i.test(blob)) {
    return "84";
  }
  if (/\bTANK68\b/i.test(blob)) {
    return "tank68he";
  }
  if (/\bBAT68\b|BATTLE68|HUAFENDA68/i.test(blob)) {
    return "huafenda68";
  }
  // 华奋达 DK63Star（0C45:80F8）：与星闪 DK63 V2 同为 63 矩阵（单灯）
  // 星闪「DK63 Star」仍为 68，不可按名称一律改成 63
  if (
    (solution === "huafenda" || (vid === 0x0c45 && pid === 0x80f8)) &&
    (/\bDK63\s*STAR\b/i.test(blob) || /\bDK63STAR\b/i.test(blob))
  ) {
    return "63";
  }
  if (/\bDK63\s*STAR\b/i.test(blob) || /\bDK63STAR\b/i.test(blob)) {
    return "68";
  }
  if (/\bES68\b|DK68|DEEP68/i.test(blob)) {
    if (/EVO/i.test(blob)) return "68EVO";
    return "68";
  }
  if (/\bDK75\s*SINGLE\b/i.test(blob)) return "dk75Single";
  if (/\bDK75\s*E\b/i.test(blob)) return "dk75E";
  if (/\bDK75\s*PRO\b/i.test(blob) || /\bZE75\b/i.test(blob)) return "dk75Pro";
  if (/\bDK75\b/i.test(blob)) return "dk75";
  if (/\bES98\b/i.test(blob) && !/\bES68\b/i.test(blob)) {
    return "99";
  }

  return "68";
}
